import { HandleType } from '@kanda-libs/ks-component-ts';
import { ButtonTextVariant } from '@kanda-libs/ks-design-library';

import { BasePage } from '../constants';

export const TICKBOX_PROPS = {
  handle: 'checkbox' as HandleType,
};

export const BUTTON_PROPS = {
  icon: 'check',
  left: true,
  variant: 'gradient' as ButtonTextVariant,
  size: 48,
  className: 'mt-4',
};

export const FIELD_TEXT: Record<BasePage, string> = {
  preContact:
    'I have read and taken time to consider the pre-contract application',
  creditAgreement:
    "By ticking this box and clicking 'Continue', I am in effect signing the agreement, agree to be legally bound by its terms, and confirm that I understand all information provided to me up to this point",
  directDebit:
    'I have taken time to consider the direct debit agreement and confirm the above',
};
